module.exports = {"Work2":{"daobanList":[{"title":"1:是否办理市外迁入-大、中专学生入学、毕业、转（退）学入户（接收普通高校本科应届毕业生）)","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、居民户口簿","state":"必要"},{"name":"2、居民居住证","state":"必要"},{"name":"3、毕业证书","state":"必要"},{"name":"4、学位证书","state":"必要"},{"name":"5、毕业生就业协议书","state":"必要"},{"name":"6、不动产权证书（或入户地址材料）","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdw-2.json
// module id = 1297
// module chunks = 0